import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface StudentSidebarProps {
  className?: string;
}

const StudentSidebar: React.FC<StudentSidebarProps> = ({ className }) => {
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const menuItemClassName = (active: boolean): string => `
    flex items-center min-h-[40px] pl-10 pr-4 py-1.5 rounded-md text-sm font-medium
    focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 focus-visible:ring-offset-[#111827]
    ${active ? 'text-white bg-[#1F2937]' : 'text-[#CBD5E1] bg-transparent hover:bg-[#1F2937] hover:text-white'}
  `.trim();

  return (
    <div className={`space-y-5 ${className || ''}`}>
      <div>
        <h3 className="text-sm font-medium text-[#CBD5E1] hover:text-white transition-colors pl-2">
          Learning
        </h3>
        <div className="mt-2 space-y-1">
          <Link
            to="/student/dashboard"
            className={menuItemClassName(isActive('/student/dashboard'))}
          >
            <span className="whitespace-normal leading-tight">Dashboard</span>
          </Link>
          <Link
            to="/student/avail-courses"
            className={menuItemClassName(isActive('/student/avail-courses'))}
          >
            <span className="whitespace-normal leading-tight">Available Courses</span>
          </Link>
          <Link
            to="/student/courses"
            className={menuItemClassName(isActive('/student/courses'))}
          >
            <span className="whitespace-normal leading-tight">My Courses</span>
          </Link>
          <Link
            to="/student/exams"
            className={menuItemClassName(isActive('/student/exams'))}
          >
            <span className="whitespace-normal leading-tight">Mock Exams</span>
          </Link>
          <Link
            to="/student/offline-exams"
            className={menuItemClassName(isActive('/student/offline-exams'))}
          >
            <span className="whitespace-normal leading-tight">Offline Exams</span>
          </Link>
          <Link
            to="/student/notifications"
            className={menuItemClassName(isActive('/student/notifications'))}
          >
            <span className="whitespace-normal leading-tight">Notifications</span>
          </Link>
        </div>
      </div>

      <div>
        <h3 className="text-sm font-medium text-[#CBD5E1] hover:text-white transition-colors pl-2">
          Performance
        </h3>
        <div className="mt-2 space-y-1">
          <Link
            to="/student/reports"
            className={menuItemClassName(isActive('/student/reports'))}
          >
            <span className="whitespace-normal leading-tight">Reports</span>
          </Link>
        </div>
      </div>

      <div>
        <h3 className="text-sm font-medium text-[#CBD5E1] hover:text-white transition-colors pl-2">
          Account
        </h3>
        <div className="mt-2 space-y-1">
          <Link
            to="/student/profile"
            className={menuItemClassName(isActive('/student/profile'))}
          >
            <span className="whitespace-normal leading-tight">Profile</span>
          </Link>
          <Link
            to="/student/subscription"
            className={menuItemClassName(isActive('/student/subscription'))}
          >
            <span className="whitespace-normal leading-tight">Subscription</span>
          </Link>
          <Link
            to="/student/settings"
            className={menuItemClassName(isActive('/student/settings'))}
          >
            <span className="whitespace-normal leading-tight">Settings</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StudentSidebar;
